// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as BuildingBDefault } from '../../../../../ui-v3/src/assets/icons/default/general/building-b.svg?react';
import { ReactComponent as BuildingBSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/BUILDING-B.svg?react';
import { createIcons } from '../../Icon';
const BuildingBIcon = /* @__PURE__ */ createIcons('BuildingB', {
    default: BuildingBDefault,
    solid: BuildingBSolid
});
BuildingBIcon.supportedTypes = [
    'default',
    'solid'
];
BuildingBIcon.category = 'general';
export default BuildingBIcon;
